// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const palkia_origin: PokeData = {
  "id": 10246,
  "name": "palkia-origin",
  "height": 63,
  "weight": 6590,
  "base_experience": 306,
  "types": [
    PokeType.WATER,
    PokeType.DRAGON
  ],
  "api_moves": [
    "hydro-pump",
    "slash",
    "scary-face",
    "dragon-breath",
    "ancient-power",
    "water-pulse",
    "aqua-ring",
    "aura-sphere",
    "aqua-tail",
    "power-gem",
    "earth-power",
    "spacial-rend"
  ],
  "moves": [
    "hydro-pump",
    "scary-face",
    "dragon-breath",
    "ancient-power",
    "aqua-tail",
    "earth-power",
    "scale-shot",
    "aqua-jet",
    "dragon-pulse",
    "outrage",
    "dragon-fang",
    "brine",
    "water-spout"
  ],
  "evolution_chain": {
    "id": 245,
    "item": null,
    "species": [
      {
        "name": "palkia",
        "order": 485,
        "types": [
          PokeType.WATER,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 108,
    "speed": 130,
    "ability_power": 162
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
